export default __webpack_public_path__ + "static/media/avatar01.04a0c374.png";